interface LastActionInfo {
  action: string
  datasetId: string
}

export interface LastActionManager {
  set({ action, datasetId }: LastActionInfo): void
  get(): LastActionInfo | undefined
  clear(): void
}

export class LastActionManagerImpl implements LastActionManager {
  #lastActionInfo: LastActionInfo | undefined = undefined

  set({ action, datasetId }: LastActionInfo): void {
    this.#lastActionInfo = { action, datasetId }
  }

  get(): LastActionInfo | undefined {
    return this.#lastActionInfo
  }

  clear(): void {
    this.#lastActionInfo = undefined
  }
}

export const createLastActionManager = (): LastActionManager => {
  return new LastActionManagerImpl()
}